import React from "react";
import strings from "../../core/translate";

/**
 * Row actions as separate icons instead of one "Actions" dropdown: what you can
 * do with a row is visible at a glance and reachable in a single click.
 *
 * An action marked `primary` keeps its label showing next to the icon. Use it
 * for the one action the row exists for — an icon alone says nothing until it
 * is hovered, which is no way to offer the step the whole screen leads to.
 *
 * <RowActions
 *   actions={[
 *     { key: "edit", icon: "fa fa-pencil", label: strings.edit, onClick, show: canWrite },
 *     { key: "delete", icon: "fa fa-trash", label: strings.delete, onClick, danger: true },
 *   ]}
 * />
 */
const RowActions = ({ actions = [] }) => {
  const visible = actions.filter(
    (action) => action && action.show !== false && action.onClick
  );

  if (visible.length === 0) {
    return <span className="row-actions__none">—</span>;
  }

  return (
    <div className="row-actions">
      {visible.map((action) => (
        <button
          key={action.key || action.label}
          type="button"
          className={`row-action${action.danger ? " row-action--danger" : ""}${
            action.primary ? " row-action--primary" : ""
          }`}
          title={action.label}
          aria-label={action.label}
          disabled={action.disabled}
          onClick={(event) => {
            event.stopPropagation();
            action.onClick(event);
          }}
        >
          <i className={action.icon} />
          {action.primary && (
            <span className="row-action__label">{action.label}</span>
          )}
        </button>
      ))}
    </div>
  );
};

// the two every list has, so screens do not repeat the icon names
export const editAction = (onClick, show = true) => ({
  key: "edit",
  icon: "fa fa-pencil",
  label: strings.edit,
  onClick,
  show,
});

export const deleteAction = (onClick, show = true) => ({
  key: "delete",
  icon: "fa fa-trash",
  label: strings.delete,
  onClick,
  danger: true,
  show,
});

/**
 * The open/closed switch, in place of a delete. It reads as the state the row
 * is in, and pressing it moves to the other one — closing is marked dangerous,
 * reopening is not, since only one of the two takes anything away.
 */
export const toggleActiveAction = (isActive, onClick, show = true) => ({
  key: "toggle-active",
  icon: isActive ? "fa fa-toggle-on" : "fa fa-toggle-off",
  label: isActive ? strings.deactivate : strings.activate,
  onClick,
  danger: isActive,
  show,
});

export const viewAction = (onClick, show = true) => ({
  key: "view",
  icon: "fa fa-eye",
  label: strings.open,
  onClick,
  show,
});

export default RowActions;
